import angular from 'angular';
import CaseMap from '../../models/case-map';
import ClioServ from '../../services/clio';

class lfCaseListCtrl {
  constructor($scope, $location, CaseMap, Clio) {
    this.caseMap = CaseMap
    this.location = $location
    this.clioServ = Clio

    this.caseMap.subscribe(data => {
      this.cases = CaseMap.toArray()
    })
    $scope.$on('displayCases', (e, displayCases) => {
      this.toggleCases(displayCases)
    })

    if (!(this.case && this.case.id)) {
      this.toggleCases()
    }

    // CaseMap.api.get()

  }
  $onChanges(d) {}
  toggleCases(displayCases = null) {
    this.asideCasesVisible = displayCases === null ?
      !this.asideCasesVisible : displayCases

    if (this.asideCasesVisible) {
      this.caseMap.api.get();
    }
  }
  syncClio() {
    if (this.clioSyncInProgress) {
      return;
    }
    this.clioSyncInProgress = true
    this.clioServ.sync({}, () => this.caseMap.api.get().then(() => {
      this.clioSyncInProgress = false
    }))
  }
  setCase(caseId) {
    this.location.path(`/${this.route || 'home'}/${caseId}`);
    this.toggleCases(false);
  }

}
lfCaseListCtrl.$inject = ['$scope', '$location', 'CaseMap', 'Clio']

function lfCaseList($location, CaseMap) {
  return {
    restrict: 'E',
    template: require('./lf-case-list.html'),
    scope: {},
    bindToController: {
      case: '<',
      account: '<',
      route: '@'
    },
    controllerAs: '$ctrl',
    controller: lfCaseListCtrl
  };
}
lfCaseList.$inject = ['$location', 'CaseMap'];

export default angular.module('directives.lfCaseList', [CaseMap, ClioServ])
  .directive('lfCaseList', lfCaseList)
  .name;



// WEBPACK FOOTER //
// ./project/directives/lf-case-list/index.js